import { gsap, ScrollToPlugin, ScrollTrigger } from "gsap/all";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);
gsap.config({nullTargetWarn: false});

export const getAnchor = (link) => {
    if (
      link.protocol !== window.location.protocol ||
      link.host !== window.location.host ||
      link.pathname !== window.location.pathname ||
      link.search !== window.location.search
    ) {
      return false;
    }
  
    return link.hash;
}

export const scrollToHash = (hash, e) => {
    const elem = hash ? document.querySelector(hash) : false;
    if(e && hash) e.preventDefault();
    if(elem) gsap.to(window, {scrollTo: { y: elem, offsetY: 100 } });
}

const addActiveClass = (menuLinks, index) => {
  if(menuLinks.length > 0) menuLinks[index].classList.add('active');
}

const removeActiveClass = (menuLinks, index) => {
  if(menuLinks.length > 0) menuLinks[index].classList.remove('active');
}

const inViewport = (items, stickyMenu, menuLinks, windowHeight) => {
  items.forEach((element, index) => {
    if(element.getBoundingClientRect().top < windowHeight / 2) {
        addActiveClass(menuLinks, index);
        if (index >= 1) removeActiveClass(menuLinks, index - 1);
    } else if (index !== 0) {
      removeActiveClass(menuLinks, index);
    }
    
    if (index == items.length - 1) {
      if(element.getBoundingClientRect().top <= 0) {
        stickyMenu.classList.add('opacity-0', 'pointer-events-none');
      } else {
        stickyMenu.classList.remove('opacity-0', 'pointer-events-none');
      }
    }
  });
}

export const toggleStickyMenu = (sectionStickyMenu) => {
  if (!sectionStickyMenu.length > 0) return;

  const windowHeight = window.innerHeight;

  sectionStickyMenu.forEach((section) => {
    const items = section.querySelectorAll('.section-gpx');
    const stickyMenu = section.querySelector('.sticky-menu');
    const menuLinks = section.querySelectorAll('.sticky-menu a');

    inViewport(items, stickyMenu, menuLinks, windowHeight);

    window.addEventListener('scroll', () => { inViewport(items, stickyMenu, menuLinks, windowHeight) });
  });
}
  